export enum ImageCropperModifier {
  FIXED_SQUARE_60_60 = 'image-cropper--fixed-square-60-60',
}
